import { WORKOUT_KEY } from '../../../../../modules/workout/model/constants/key'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'

function getOriginalParentIdWorkoutUtil (workout) {
  return getValueReduxUtil(workout, WORKOUT_KEY.ORIGINAL_PARENT_ID)
}

export default getOriginalParentIdWorkoutUtil
